// This will simply check the number or paragraphs then turn on formatting

export const useDocumentParagraphDiagnostics = (documentId: string) =>
  defineStore(`/document/${documentId}/diagnostics/paragraphs`, () => {
    const diagnosticsLabel = ref("Checking document paragraphs.");
    const diagnosticsErrorMessage = ref("");

    const hasPassedDiagnostics = ref(false);

    const documentChecklistStore = useDocumentChecklistStore(documentId);
    const { hasCorrectNumberOfBodyParagraphs, numExpectedBodyParagraphs } =
      storeToRefs(documentChecklistStore);

    const documentEvaluativeParagraphsStore =
      useDocumentEvaluativeParagraphsStore(documentId);
    const { numBodyParagraphs } = storeToRefs(
      documentEvaluativeParagraphsStore
    );

    const isRunning = ref(false);
    const runDiagnostics = async () => {
      isRunning.value = true;

      await new Promise((resolve) => setTimeout(resolve, 2000));

      hasPassedDiagnostics.value = hasCorrectNumberOfBodyParagraphs.value;

      if (hasCorrectNumberOfBodyParagraphs.value != true) {
        useDocumentShowFormattingStore(documentId).setShouldShowFormatting(
          true
        );

        diagnosticsErrorMessage.value = `The document expects ${numExpectedBodyParagraphs.value} paragraphs, but you have submitted ${numBodyParagraphs.value} paragraphs. Please review your work and check if you have added any extra hard enters or forggoten to press enter.`;
      }

      isRunning.value = false;
    };

    return {
      diagnosticsLabel,
      isRunning,
      hasPassedDiagnostics,
      diagnosticsErrorMessage,
      runDiagnostics,
    };
  });
